import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import BaseAlertModal from "./BaseAlertModal";

const MeasurementDeleteModal = ({
    modalButton,
    modalButtonSetter,
    submitAction,
    title,
    message,
}) => {
    const [isDeletingCloud, setIsDeletingCloud] = useState(false);
    const { t } = useTranslation();

    const closeModal = () => {
        setIsDeletingCloud(false);
        modalButtonSetter(false);
    };

    const handleDelete = () => {
        return new Promise((resolve, reject) => {
            setIsDelete(true);
            submitAction()
                .then(() => resolve())
                .catch(() => {
                    setIsDelete(false);
                    reject();
                })
                .finally(() => closeModal());
        });
    };

    const setIsDelete = (state) => {
        setIsDeletingCloud(state);
    };

    return (
        <>
            <BaseAlertModal
                isVisible={modalButton}
                setIsVisible={modalButtonSetter}
                title={title}
                message={message}
                action={{
                    submitAction: () => handleDelete(),
                    name: t("delete"),
                }}
                isSubmitting={isDeletingCloud}
                type="delete"
            />
        </>
    );
};

export default MeasurementDeleteModal;
